import { createGlobalStyle, css } from 'styled-components'
import Media from './media'

const AnimateTargetCSS = css`
  .animate-target {
    opacity: 0;
  }
`

export const GlobalStyle = createGlobalStyle`
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #f5f5fa;
    outline: none;
    min-width: 1200px;
  }
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
  }
  body {
    font-family: Inter, MarkPro, sans-serif;
  }
  a {
    text-decoration: none;
    color: #F3512B;
    cursor: pointer;
  }
  button {
    outline: none;
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    cursor: pointer;
  }
  li {
    list-style: none;
  }
  div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, button, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
  }
  button, input, select, textarea {
    font-size:100%;
  }
  img {
    border: 0px;
  }
  ${Media.lessThan(Media.small)} {
    html, body {
      min-width: unset;
    }
  }
  ${AnimateTargetCSS};
`
